import {connect} from 'react-redux';
import ManagersPanel from './ManagersPanel.jsx';
import {
  handleManagerAddClick,
  handleManagerSaveClick,
  handleManagerEditClick,
  handleManagerCancelClick,
  handleManagerRemoveClick
} from './actions';

const mapStateToProps = state => ({
  managers: state.tournament.permissions.managers,
  userEmail: state.shared.auth.email
});

const mapDispatchToProps = dispatch => ({
  onAddManagerClick: () => dispatch(handleManagerAddClick()),
  onSaveClick: id => dispatch(handleManagerSaveClick(id)),
  onEditClick: (id, email) => dispatch(handleManagerEditClick(id, email)),
  onCancelClick: () => dispatch(handleManagerCancelClick()),
  onRemoveClick: id => dispatch(handleManagerRemoveClick(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(ManagersPanel);



// WEBPACK FOOTER //
// ./src/features/tournament/permissions/ManagersPanelContainer.jsx